// Small formatting helpers.

export function money(n: number | null | undefined, cur = "USD"): string {
  const v = Number(n) || 0;
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: cur, maximumFractionDigits: 2 }).format(v);
  } catch {
    return `$${v.toFixed(2)}`;
  }
}

// Currency shown in parentheses for cost lines.
export function cost(n: number | null | undefined, cur = "USD"): string {
  return `(${money(Math.abs(Number(n) || 0), cur)})`;
}

// Mass amount in the business's mass unit (UK: "kg", US: "lb"). The engine stores all masses in that
// unit — the field names historically say "Lbs" but the value is whatever `massUnit` is.
export function mass(n: number | null | undefined, unit = "lb"): string {
  const v = Number(n) || 0;
  const digits = v !== 0 && Math.abs(v) < 1 ? 3 : v < 100 ? 2 : 1;
  return `${v.toLocaleString("en-US", { maximumFractionDigits: digits })} ${unit}`;
}
/** @deprecated use mass(n, massUnit) — kept so callers that haven't been updated still compile. */
export const lbs = mass;

export function num(n: number | null | undefined, digits = 0): string {
  return (Number(n) || 0).toLocaleString("en-US", { maximumFractionDigits: digits });
}

export function pct(n: number | null | undefined, digits = 0): string {
  return `${((Number(n) || 0) * 100).toFixed(digits)}%`;
}

// ISO date (YYYY-MM-DD) → "12 Jun 2026"; passthrough if unparseable.
export function fmtDate(s: string | undefined | null): string {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleDateString("en-US", { day: "numeric", month: "short", year: "numeric" });
}

export function todayISO(): string {
  // Local calendar date (not UTC) so it matches the user's "today".
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

// Days until a date (negative = past).
export function daysUntil(s: string | undefined | null): number | null {
  if (!s) return null;
  const d = new Date(s);
  if (isNaN(d.getTime())) return null;
  return Math.round((d.getTime() - Date.now()) / 86400000);
}
